// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__ljfX5","container":"Footer_container__SDIP5","links":"Footer_links__LyTEp","copyright":"Footer_copyright__8uYb1"};